exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wl-container[data-v-75629cb2] {\n  height: 100%;\n  background: #eff1f5;\n  padding: 0.114583rem;\n}\n.wl-content-container[data-v-75629cb2] {\n  background: #fff;\n  height: 100%;\n  padding: 0.114583rem 0.114583rem 0.083333rem 0.114583rem;\n  border-radius: 0.041667rem;\n}\n.wl-search-bar[data-v-75629cb2] {\n  height: 45PX;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n.wl-left[data-v-75629cb2],\n.wl-right[data-v-75629cb2] {\n  display: flex;\n  justify-content: flex-start;\n  justify-items: center;\n}", ""]);

// exports
